const findUserRank = (score, rankData) => {
	const userRank = rankData.find(rank => {
		return score >= rank.minScore && score <= rank.maxScore;
	});
	return userRank ? userRank.rank : 'Rank not found';
};

export default findUserRank;